import React from "react";
import PropTypes from "prop-types";
import Popovers from "../Popovers/Popovers";

/*
Toggle Switch Component
Note: id is required for ToggleSwitch component to function. Name, currentValue, defaultChecked, Small and onChange are optional.
Usage: <ToggleSwitch id="id" onChange={function (e) { console.log("Checkbox Current State: " + e.target.checked); }} />
*/

class ToggleSwitch extends React.Component {
  constructor(props) {
    super(props);

    // Get the initial checked value from the URL search parameters or use the default value
    const urlParams = new URLSearchParams(window.location.search);
    let initialChecked = urlParams.get(this.props.id) != "false";

    // For the protection manual, default it false.
    if (this.props.id === "pm") {
        if (urlParams.get(this.props.id) === "true") {
            initialChecked = true;
        }
        else {
            initialChecked = this.props.defaultChecked;
        }
    }

    this.state = {
      checked: initialChecked,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // Update the URL search parameter when the checkbox state changes
    if (prevState.checked !== this.state.checked) {
      const { id } = this.props;
      const urlParams = new URLSearchParams(window.location.search);

      // Set the parameter value or delete it if it's false
      if (this.state.checked) {
        urlParams.set(id, "true");
      } else {
        urlParams.set(id, "false");
      }

      // Replace the current URL without triggering a full page reload
      const newURL = `${window.location.pathname}?${urlParams.toString()}`;
      window.history.replaceState({ path: newURL }, "", newURL);
    }
  }

  onChange = (e) => {
    const { id } = this.props;

    this.setState({ checked: e.target.checked }, () => {
      if (typeof this.props.onChange === "function") {
        this.props.onChange(this.state.checked, id);
      }
    });
  };

  render() {
    let title ='';

    if (this.props.mobileTitle === undefined) {
      title = <div className="search-view-description">{this.props.title}{this.props.tooltip && <span><Popovers text={this.props.tooltip}/></span>}</div>;
    }
    else {
      title = <div className="search-view-description"><span className='d-none d-md-inline'>{this.props.title}</span><span className='d-md-none'>{this.props.mobileTitle}</span>{this.props.tooltip && <span><Popovers text={this.props.tooltip}/></span>}</div>;
    }
    return (
      <div className={"block block-unhcr-search block-block-search-text-toggler " + this.props.name}>
        <div className="content">
          <div className="search-filter-toggle">
            {title}
            <label className="toggler-wrapper style-blue">
              <input
                type="checkbox"
                name={this.props.name}
                className="toggle-switch-checkbox"
                id={this.props.id}
                checked={this.state.checked}
                onChange={this.onChange}
              />
              <div className="toggler-slider">
                <div className="toggler-knob"></div>
              </div>
            </label>
          </div>
        </div>
      </div>
    );
  }
}

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool,
  currentValue: PropTypes.bool,
  title: PropTypes.string,
  mobileTitle: PropTypes.string,
  tooltip: PropTypes.string,
};

ToggleSwitch.defaultProps = {
  tooltip: "",
};

export default ToggleSwitch;
